<template>
	<div>

		<!-- 店铺详情 -->
		<cube-page :title="isAdd ? '分销商申请':'分销商编辑'">
			<div slot="content">
				<div class="shopxq leopages">
					<van-form @submit="onSubmit">
						<van-field v-model="entry.nickname" clearable label="公司名称" placeholder="公司名称" name="nickname" required
							:rules="[{ required: true, message: '请填写公司名称' }]" />
						<van-field v-model="entry.address" clearable label="公司地址" placeholder="公司地址" name="address"
							right-icon="location-o" required :rules="[{ required: true, message: '请填写公司地址' }]" />
						<van-field v-model="entry.contacts" clearable label="联系人" placeholder="联系人" name="contacts" required
							:rules="[{ required: true, message: '请填写联系人' }]" />
						<van-field v-model="entry.mobile" clearable label="手机号码" placeholder="手机号码" name="mobile" required
							:rules="[{ required: true, message: '请填写联系电话' }]" />
						<van-field v-model="entry.landline" clearable label="座机" placeholder="座机" name="landline" />
						<van-field v-model="entry.username" clearable label="用户名" placeholder="英文/数字/符号组合，6-30 位长度，不可有空格" name="username" required
							:rules="[{ required: true, message: '请填写用户名' }]" />
						<van-field v-model="entry.password" clearable label="密码" placeholder="密码为空时,不进行密码更改" name="password" type="password" />
						<van-field name="avatar" label="头像" v-if="!isAdd">
							<template #input>
								<van-uploader :after-read="afterRead" v-model="fileList" :max-count="1" />
							</template>
						</van-field>
						<van-field name="license" label="营业执照" required :rules="[{ required: true, message: '请上传营业执照' }]">
							<template #input>
								<van-uploader :after-read="afterReadId" v-model="fileIdList" :max-count="1" />
							</template>
						</van-field>
						<!-- <van-field v-model="entry.store" clearable label="开通小店" name="store" type="checkbox" /> -->
						<van-field label="开通小店" name="dtd" store="align-items: center;" class="vanfield">
							<template #input>
								<van-checkbox v-model="entry.store" shape="square"></van-checkbox>
							</template>
						</van-field>
						<div style="margin: 16px;">
							<van-button round block type="info" native-type="submit">提交</van-button>
						</div>
						<van-field name="checkbox" class="tk">
							<template #input>
								<van-checkbox v-model="checked">我已阅读，并同意<a class="agree" @click="goXieyi">《免责申明》和《用户注册服务协议》</a></van-checkbox>
							</template>
						</van-field>
					</van-form>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import * as imgcl from '@/utils/img'
	import wx from 'weixin-js-sdk'
	import Exif from "exif-js";

	import {
		VueCropper
	} from 'vue-cropper'
	import {
		redirect
	} from "@/utils/network";
	export default {
		components: {
			CubePage,
			VueCropper
		},
		data() {
			return {
				isAdd: this.$route.params.bj ? false : true,
				entry: {
					nickname: '', //	公司名称
					username: '', //用户名
					password: '', //密码
					mobile: '', //	联系电话
					landline: '', //		座机
					address: '', //	地址
					contacts: '', //	联系人
					avatar: '', //	执照
					license: '',
					store: 0,
				},
				avatarobj: '', //头像上传
				imageFileName: '',
				showCropper: false,
				files: {
					name: "",
					type: "",
				},
				idcardobj: '', //证件上传
				fileList: [],
				checked: false,
				fileIdList: [],
				strCropper: null
			}
		},
		methods: { //跳转协议页
			goXieyi() {

				redirect('xieyi?place=102');

				/*let that = this;
				var url = "/addons/litestore/api.account/getAgree"
				//这里直接调用网络接口
				util.get(url, {
						type: 2
					},
					function(result) {
						if (result.code == 1) {
              redirect(path);
							that.$router.push({
								name: 'xieyi',
								params: {
                  place: 102
								}
							})
						} else {
							Dialog.alert({
								title: '温馨提示',
								message: result.msg
							})
						}
					},
				);*/
			},

			beforeDelete(i) {
				removeAaary(this.fileList, i);
				this.$emit("beforeDelete", i);
			},
			afterReadId(file) {
				this.idcardobj = ''
				this.files.name = file.file.name; // 获取文件名
				this.files.type = file.file.type; // 获取类型
				this.strCropper = 'idcard'
				this.imgPreview(file.file, 300);
				// this.option.img = file.content //清空上一次裁剪的图片
			},
			afterRead(file) {
				this.avatarobj = ''
				this.files.name = file.file.name; // 获取文件名
				this.files.type = file.file.type; // 获取类型
				this.strCropper = 'avatar'
				this.imgPreview(file.file, 300);
			},
			imgPreview(file, sizekb) {
				let self = this;
				let Orientation;
				//去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
				Exif.getData(file, function() {
					Orientation = Exif.getTag(this, "Orientation");
				});
				// 看支持不支持FileReader
				if (!file || !window.FileReader) return '不支持FileReader';
				if (/^image/.test(file.type)) {
					// 创建一个reader
					let reader = new FileReader();
					// 将图片2将转成 base64 格式
					reader.readAsDataURL(file);
					// 读取成功后的回调
					reader.onloadend = function() {
						let result = this.result;
						let img = new Image();
						img.src = result;
						//判断图片是否大于500K,是就直接上传，反之压缩图片
						if (this.result.length <= sizekb * 1024) {
							// 上传图片
							if (self.strCropper == 'avatar') {
								self.avatarobj = this.result;
								console.log('小于avatarobj：', this.result)
							} else if (self.strCropper == 'idcard') {
								self.idcardobj = this.result;
								console.log('idcardobj<：', self.idcardobj)
							}
						} else {
							img.onload = function() {
								let data = imgcl.compress(img, Orientation);
								console.log('大于：', data)
								if (self.strCropper == 'avatar') {
									self.avatarobj = data
								} else if (self.strCropper == 'idcard') {
									self.idcardobj = data;
									console.log('idcardobj>：', self.idcardobj)
								}
							};
						}
					};
				}
			},
			onSubmit(values) {
				let that = this;
				if (!that.checked) {
					Toast('请勾选并阅读条款')
					return
				}
				if (that.avatarobj) {
					that.entry.avatar = that.avatarobj
				} else if (that.fileList.length > 0) {
					that.entry.avatar = that.fileList[0].url
				}

				// that.entry.avatar = that.avatarobj ? that.avatarobj : that.fileList[0].url
				that.entry.license = that.idcardobj ? that.idcardobj : that.fileIdList[0].url
				if (that.$route.query.share_id) {
					that.entry.share_id = this.$route.query.share_id
				}

				var pram = {
					row: that.entry
				};
				pram.row.pact = that.checked ? 1 : 0;
				console.log(pram)
				var url = "/addons/litestore/api.account/applyDistributor"
				if (!that.isAdd) {
					url = "/addons/litestore/api.account/editDistributor"
				}
				//这里直接调用网络接口
				util.post(url, pram,
					function(result) {
						Toast(result.msg);
						setTimeout(() => {
							if (that.isAdd && !result.data.subscribe) {
								util.redirect('newfollow');
								return false;
							}
							util.redirect(result.data.url);
							/*that.$router.back();
							that.claer();*/
						}, 1000)
					},
				);
			},
			getData() {
				let that = this;
				var url = "/addons/litestore/api.account/editDistributor"
				//这里直接调用网络接口
				util.get(url, {},
					function(result) {
						if (result.data != null) {
							that.isAdd = false
							let en = {
								nickname: result.data.nickname, //	公司名称
								username: result.data.username, //用户名
								//password: result.data.password, //密码
								mobile: result.data.mobile, //	联系电话
								landline: result.data.landline, //		座机
								address: result.data.address, //	地址
								contacts: result.data.contacts, //	联系人
								avatar: result.data.avatar, //	执照,
								license: result.data.license,
								store: result.data.store
							};
							let a = [{
								url: result.data.avatar
							}]
							that.fileList = a
							let b = [{
								url: result.data.license
							}]
							that.fileIdList = b
							that.entry = en
							that.checked = result.data.pact;
						}
					},
				);
			},
			claer() {
				let that = this;
				that.entry = {
					nickname: '', //	公司名称
					username: '', //用户名
					password: '', //密码
					mobile: '', //	联系电话
					landline: '', //		座机
					address: '', //	地址
					contacts: '', //	联系人
					avatar: '', //	执照
					license: ''
				}
				that.imageFileName = ''
				that.showCropper = false
			},
		},
		created() {
			this.getData()
		}
	}
</script>
<style type="text/css" lang="less">
	.van-form {
		background-color: #FFFFFF;
		padding: 20px 0;

		.tk {
			font-size: 12px;
			text-align: center;

			a {
				color: #000;
			}

			.van-field__control:read-only {
				justify-content: center !important;
			}
		}
	}

	.van-nav-bar {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.van-hairline--bottom::after {
		border-bottom-width: 0px;
	}

	.height100 {
		height: 100vh;
	}

	.flex-column-center {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.vue-cropper {
		background: #000 !important;

		.cropper-view-box {
			outline: 1px solid #fff !important;
			outline-color: #fff !important;
		}
	}

	.footerB {
		background: #000 !important;
		padding: 10px 15px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.fitem {
			color: #FFFFFF;
			// width:50px;
		}
	}
	.vanfield {
		.van-field__value {
			flex: none;
		}
		.van-icon-success {
			border-radius: 4px;
		}
	}
</style>
